import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED } from 'common/hitlistTaskConstants';

import { SR_API_ACTION_HITLIST_TASK_SEND_VOICEMAIL_FOLLOW_UP_TEXT } from 'api/actionTypes';

import useDispatch from 'client/hooks/useDispatch';
import postWithState from 'client/actions/postWithState';

import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const HitlistTaskSendFollowUpTextButton = ({ hitlistTask, getHitlistTasks }) => {
  const [isBusy, setIsBusy] = useState(false);
  const dispatch = useDispatch();

  const onSendFollowUpTextButtonClick = useCallback(() => {
    if (!global.confirm('Are you sure you want to send the "I called you" text?')) {
      return;
    }
    setIsBusy(true);
    dispatch(postWithState, {
      action: SR_API_ACTION_HITLIST_TASK_SEND_VOICEMAIL_FOLLOW_UP_TEXT,
      payload: {
        hitlistTaskId: hitlistTask.id,
      },
      onError(error) {
        global.alert(
          `Error while sending the follow up text: ${error.originalMessage || error.message}`,
        );
      },
    }).then(() => {
      if (getHitlistTasks) {
        getHitlistTasks();
      }
    });
  }, [hitlistTask, getHitlistTasks, setIsBusy, dispatch]);

  if (hitlistTask.callOutcome !== SR_HITLIST_TASK_CALL_OUTCOME_NOT_ANSWERED) {
    return null;
  }

  return (
    <SrBox margin="20px 0 20px" maxWidth="445px">
      {!hitlistTask.voicemailFollowUpTextedAt && (
        <SrButton
          type="button"
          theme={SR_BUTTON_THEME_ADOBE_GREEN}
          disabled={isBusy}
          onClick={onSendFollowUpTextButtonClick}
        >
          No Answer: Send "I called you" text now
        </SrButton>
      )}

      {hitlistTask.voicemailFollowUpTextedAt && (
        <SrText font="greycliff">
          {`"I called you" text sent at: ${moment(hitlistTask.voicemailFollowUpTextedAt).format(
            'MMM D [at] h:mma',
          )}`}
        </SrText>
      )}
    </SrBox>
  );
};

HitlistTaskSendFollowUpTextButton.propTypes = {
  hitlistTask: PropTypes.object.isRequired,
  getHitlistTasks: PropTypes.func,
};

HitlistTaskSendFollowUpTextButton.displayName = 'HitlistTaskSendFollowUpTextButton';

export default HitlistTaskSendFollowUpTextButton;
